import type { ParentApp } from "@/contexts/parent-app-context"
import type { ClientRequestStatus } from "@/types/client-requests"
import { buildOnboardingPath } from "@/lib/client-request-action-utils"

// The request id and phase arrive in a message from the onboarding-form iframe, so only an id shape is accepted, an
// unknown phase gets the default route, and the route is always built here.
const REQUEST_ID = /^[A-Za-z0-9-]{1,64}$/

// The onboarding form's pre-verification phases as the client-request statuses the Portal host picks its route by.
const STATUS_BY_PHASE = new Map<string, ClientRequestStatus>([
  ["Draft", "Draft"],
  ["NotSent", "RequestInitiated"],
  ["WithWorker", "VerifyingWorker"],
  ["OnHold", "OnHold"],
  ["Submitted", "ReviewWorkerInfo"],
  ["RequiresReview", "RequestInitiated"],
  ["ApprovedSinceOpened", "WorkerInfoReviewed"],
  ["Approved", "WorkerInfoReviewed"],
  ["Discarded", "Canceled"],
  ["Cancelled", "Canceled"],
])

/**
 * The host route of the pre-verification screen for a gw-sync request id, or null when the id is not one. A client
 * request is routed by its own status, which the grid row carries; the phase stands in for it otherwise.
 */
export function buildPreVerificationRoute(
  requestId: unknown,
  parentApp: ParentApp,
  phase?: unknown,
  sourceStatus?: ClientRequestStatus,
): string | null {
  if (typeof requestId !== "string" || !REQUEST_ID.test(requestId)) return null
  const status = sourceStatus ?? (typeof phase === "string" ? STATUS_BY_PHASE.get(phase) : undefined)
  return buildOnboardingPath(parentApp, requestId, status)
}
